module.exports = __webpack_public_path__ + "img/mycrypto.5a735d59.png";